module.exports = __webpack_public_path__ + "img/symbol_8.1c466a7c.png";